module.exports = __webpack_public_path__ + "img/20180815_145537_006.e06506be.jpg";